// services/leads-fila.service.ts
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { BaseApiService } from './base-api.service';
import { LeadHistoricoRequest, LeadHistoricoResponse, LeadHistoricoResumo } from '../interfaces/lead-historico.interface';

@Injectable({
  providedIn: 'root'
})
export class LeadHistoricoService extends BaseApiService {

  getLeadHistoricoResumo(codigoDn: string, dataIni?: string, dataFim?: string): Observable<LeadHistoricoResumo> {
    let endpoint = `/lead/historico/resumo?dn=${codigoDn}`;

    // Adicionar datas apenas se ambas forem fornecidas
    if (dataIni && dataFim) {
      endpoint += `&dataIni=${dataIni}&dataFim=${dataFim}`;
    }
    
    return this.get<LeadHistoricoResumo>(endpoint).pipe(
      catchError((error) => {
        console.error('LeadHistoricoService - Error:', error);
        return throwError(() => error);
      })
    );
  }

  getLeadHistorico(request: LeadHistoricoRequest): Observable<LeadHistoricoResponse> {
    return this.post<LeadHistoricoResponse>('/lead/historico', request).pipe(
      catchError((error) => {
        console.error('LeadHistoricoService - Error:', error);
        return throwError(() => error);
      })
    );
  }
}


